module.exports = __webpack_public_path__ + "img/bone.club.e671bdbd.png";